import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full cursor-default items-center gap-2 rounded-md border bg-white p-2 text-xs transition-all" }
const _hoisted_2 = { class: "flex w-8 items-center justify-center" }
const _hoisted_3 = { class: "flex min-w-0 flex-1 flex-col gap-1" }
const _hoisted_4 = { class: "text-foreground w-full truncate font-medium" }
const _hoisted_5 = {
  key: 0,
  class: "text-muted-foreground text-[10px]"
}
const _hoisted_6 = { class: "flex items-center" }

import type { FileItem } from '@/types';
    import { Download, Eye, File, Trash2 } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';
    import { Button } from '@/components/ui/button';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'FileView',
  props: {
    file: {},
    downloadable: { type: Boolean, default: true },
    deletable: { type: Boolean, default: true },
    previewable: { type: Boolean, default: true }
  },
  emits: ["preview", "download", "delete"],
  setup(__props: any, { emit: __emit }) {

    const { t } = useI18n();

    const props = __props;

    const emit = __emit;

    const formatFileSize = (bytes: number): string => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const preview = () => {
        emit('preview', props.file);
    };

    const download = () => {
        window.open(props.file.url, '_blank');
        emit('download', props.file);
    };

    const removeFile = () => {
        emit('delete', props.file);
    };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(File), { class: "text-muted-foreground size-4" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.file.name), 1),
      (_ctx.file.size)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(formatFileSize(_ctx.file.size)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_ctx.previewable && _ctx.file.url)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            variant: "ghost_primary",
            size: "icon",
            onClick: _withModifiers(preview, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Eye), { class: "size-4" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.downloadable && _ctx.file.url)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 1,
            variant: "ghost_primary",
            size: "icon",
            onClick: _withModifiers(download, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Download), { class: "size-4" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.deletable)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 2,
            variant: "ghost_destructive",
            size: "icon",
            onClick: _withModifiers(removeFile, ["prevent"])
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Trash2), { class: "size-4" })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})